<ion-content class="ion-page brand-default">
  <div class="landing-page-container">
    <div class="signin-register-form-container">
      <div class="logo-features-pane">
        <div class="logo-container">
          <a href="/">
            <ion-img id="topmenu-logo" src="{{ logoImagePath }}" alt="Quotify Logo">
            </ion-img>
          </a>
        </div>
        <div class="feature-list">
          <div class="feature">
            <ion-icon name="document-outline"></ion-icon>
            <div>
              <h3>Create Quotes Faster</h3>
              <p>Streamline your quoting process.</p>
            </div>
          </div>
          <div class="feature">
            <ion-icon name="people-outline"></ion-icon>
            <div>
              <h3>Manage Projects Efficiently</h3>
              <p>Keep everything organized and in one place.</p>
            </div>
          </div>
          <div class="feature">
            <ion-icon name="bar-chart-outline"></ion-icon>
            <div>
              <h3>Close More Business</h3>
              <p>Turn opportunities into results.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="signin-register-pane">
        <form [formGroup]="registerUserFormGroup" (submit)="registerUser()">
          <h1>Register</h1>
          <p>Please fill in the form to create an account.</p>
          
          <div class="name-field-container">
            <div class="form-fields">
              <ion-label for="FirstName" class="light-label">First Name
                <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'FirstName')">*</ion-text>
              </ion-label>
              <ion-input #firstNameInputField type="text" id="FirstName" ngDefaultControl placeholder="First Name"
                  formControlName="FirstName" (value)="appUserRegisterRequest.FirstName" class="rounded-input">
              </ion-input>
              <error-messages [control]="registerUserFormGroup.get('FirstName')" [fieldName]="'First Name'"></error-messages>
            </div>
            <div class="form-fields">
              <ion-label for="LastName" class="light-label">Last Name
                <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'LastName')">*</ion-text>
              </ion-label>
              <ion-input #lastNameInputField type="text" id="LastName" ngDefaultControl placeholder="Last Name"
                  formControlName="LastName" (value)="appUserRegisterRequest.LastName" class="rounded-input">
              </ion-input>
              <error-messages [control]="registerUserFormGroup.get('LastName')" [fieldName]="'Last Name'"></error-messages>
            </div>
          </div>
            
          <div class="form-fields">
            <ion-label for="EmailAddress" class="light-label">Email Address
              <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'EmailAddress')">*</ion-text>
            </ion-label>
            <ion-input #emailInputField type="email" id="EmailAddress" ngDefaultControl placeholder="Email Address"
                formControlName="EmailAddress" (value)="appUserRegisterRequest.EmailAddress" class="rounded-input">
            </ion-input>
            <error-messages [control]="registerUserFormGroup.get('EmailAddress')" [fieldName]="'Email Address'"></error-messages>
          </div>
          <div class="form-fields">
            <ion-label for="Password" class="light-label">Password
              <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'Password')">*</ion-text>
            </ion-label>
            <div class="password-container">
              <ion-input #passwordInputField type="password" id="Password" ngDefaultControl placeholder="Password"
                class="rounded-input" formControlName="Password" (value)="appUserRegisterRequest.Password" togglePassword>
              </ion-input>
            </div>
            <error-messages [control]="registerUserFormGroup.get('Password')" [fieldName]="'Password'"></error-messages>
          </div>
          <div class="form-fields">
            <ion-label for="ConfirmPassword" class="light-label">Confirm Password
              <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'ConfirmPassword')">*</ion-text>
            </ion-label>
            <div class="password-container">
              <ion-input #confirmPasswordInputField type="password" id="ConfirmPassword" ngDefaultControl placeholder="Confirm Password"
                formControlName="ConfirmPassword" (value)="appUserRegisterRequest.ConfirmPassword" togglePassword class="rounded-input">
              </ion-input>
            </div>
            <error-messages [control]="registerUserFormGroup.get('ConfirmPassword')" [fieldName]="'Confirm Password'"></error-messages>
          </div>
          <div class="form-fields">
            <ion-label for="DefaultCompanyReference" class="light-label">Company Name
              <ion-text color="danger" *ngIf="isRequiredField(registerUserFormGroup,'DefaultCompanyReference')">*</ion-text>
            </ion-label>
            <ion-input #DefaultCompanyReference type="text" id="DefaultCompanyReference" ngDefaultControl
                placeholder="Company Name" formControlName="DefaultCompanyReference"
                (value)="appUserRegisterRequest.DefaultCompanyReference" class="rounded-input">
              </ion-input>
            <error-messages [control]="registerUserFormGroup.get('DefaultCompanyReference')" [fieldName]="'Company Name'"></error-messages>
          </div>
          <div class="form-fields">
            <ion-checkbox formControlName="AgreedToCustomerTermsOfUse" ngDefaultControl class="rounded-checkbox"></ion-checkbox>
            <ion-label class="light-label">
                By checking, you agree to Quoteify's
                <a (click)="onClickTermsOfUse()" style="cursor: pointer;">Customer Terms of Use</a>
            </ion-label>
            <error-messages [control]="registerUserFormGroup.get('AgreedToCustomerTermsOfUse')"
              [fieldName]="'Terms of Use Compliance'">
            </error-messages>
          </div>
          <div class="form-fields">
            <ion-button type="submit" strong="true" size="medium" fill="solid" class="">
              Register 
              <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
            </ion-button>
          </div>
          <div class="switch-form-container">
            <div>OR</div>
            <ion-router-link id="LoginLink" routerLink="/user/user-login">
              Already have an account? Sign in</ion-router-link>
          </div>
          <div>
            <ion-label>{{ userMessage }}</ion-label>
          </div>
        </form>
      </div>
    </div>
  </div>  
</ion-content>
